import { render, staticRenderFns } from "./tenantSelection.vue?vue&type=template&id=1d9bf437&scoped=true"
import script from "./tenantSelection.vue?vue&type=script&lang=js"
export * from "./tenantSelection.vue?vue&type=script&lang=js"
import style0 from "./tenantSelection.vue?vue&type=style&index=0&id=1d9bf437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9bf437",
  null
  
)

export default component.exports